import { HEADER_SIZE } from "@/utils/constants/header";
import Header from "@components/Header";
import Toast from "@components/Toast";
import { DataProviders, WebSocketProviders } from "@includes/index";
import { Box, Grid } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";

const AuthenticatedLayout: FC = () => {
  return (
    <DataProviders>
      <WebSocketProviders>
        <Toast />
        <Box height="100vh" width="100%" sx={{ maxHeight: "100vh", overflow: "hidden" }}>
          <Grid container height="100%">
            <Grid item xs={12} height={HEADER_SIZE}>
              <Header />
            </Grid>
            <Grid item xs={12} height={`calc(100vh - ${HEADER_SIZE})`}>
              <Outlet />
            </Grid>
          </Grid>
        </Box>
      </WebSocketProviders>
    </DataProviders>
  );
};

export default AuthenticatedLayout;
